import React from "react";
import { Virtualizer } from "@tanstack/react-virtual";
import { capitalizeFirstLetter } from '../../../../../../utils/shared/stringUtils';

interface MonthData {
  name: string;
  startIndex: number;
  days: number;
}

interface CalendarHeaderVirtualizedProps {
  months: MonthData[];
  columnMonthVirtualizer: Virtualizer<HTMLDivElement, Element>;
  cellWidth: number;
  rowHeight: number;
}

const CalendarHeaderVirtualized: React.FC<CalendarHeaderVirtualizedProps> = ({
  months,
  columnMonthVirtualizer,
  cellWidth,
  rowHeight,
}) => (
  <div
    className="flex sticky top-0 z-20 bg-white border-b"
    style={{ height: rowHeight }}
  >
    {columnMonthVirtualizer.getVirtualItems().map((month) => {
      const item = months[month.index];
      return (
        <div
          key={month.key}
          style={{
            position: "absolute",
            left: item.startIndex * cellWidth,
            width: item.days * cellWidth,
            height: rowHeight,
          }}
          className="flex items-center justify-start px-4 font-semibold border-r text-gray-700 text-sm shadow-sm"
        >
          <span className="sticky left-5">{capitalizeFirstLetter(item.name)}</span>
        </div>
      );
    })}
  </div>
);

export default CalendarHeaderVirtualized;
